module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAL1JREFUeNpiYCADaCb9NwBiBWLUMpJjOJA6D8QfgNjx+jzGC/jUM5HhgQ9QLADE+6EWUs8HSL7YD7UEr0/IsoAUS8i2gFhLKLKAGEsotoCQJVSxAJ8ljFCJACrZo49kFtgSkAXrqWgBOtjAAiQaod6iBlCAYpgPGmkVByAQCIyDDYw0MjwRaPgCauUDkKH3sRlOjZwsAHW5ATbDKS2LCBpOSWlKlOHkVjhEG05uhWNArOGURG4BEBOV+wECDABPFmTGEDAKjQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-right-blue.png
// module id = g90L
// module chunks = 0